import React from 'react';
import PropTypes from 'prop-types';
import Tag from './tag';
import css from './tags.module.scss';
import classnames from 'classnames';

const Tags = ({
    gaCategory,
    gaAction,
    onClickTag,
    scroll,
    tags,
    padOuterItems,
    children
}) =>
    tags?.length > 0 && (
        <div className={classnames(css.wrapper, { [css.scroll]: scroll })}>
            {scroll && children}
            <div
                className={classnames(css.tags, {
                    [css.padded]: padOuterItems
                })}>
                {!scroll && children}
                {tags.map((tag) => (
                    <Tag
                        gaCategory={gaCategory}
                        gaAction={gaAction}
                        key={tag.name}
                        name={tag.name}
                        onClick={() =>
                            typeof onClickTag === 'function' && onClickTag(tag)
                        }
                        url={tag.url}
                    />
                ))}
            </div>
        </div>
    );

Tags.defaultProps = {
    scroll: false
};

Tags.propTypes = {
    gaCategory: PropTypes.string.isRequired,
    gaAction: PropTypes.string.isRequired,
    onClickTag: PropTypes.func,
    scroll: PropTypes.bool,
    tags: PropTypes.array.isRequired
};

export default Tags;
